type UserName = { firstName: string; lastName: string };

export function compareUsersByName(a: UserName, b: UserName) {
    return a.lastName.localeCompare(b.lastName, 'de') || a.firstName.localeCompare(b.firstName, 'de');
}
